export const defaultPagination = {
  page: 0,
  perPage: 10,
};
